import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from 'shared/lib/classNames/classNames';
import { Error } from 'features/Error';
import cls from './NotFoundPage.module.scss';
export var NotFoundPage = function (_a) {
    var className = _a.className;
    return (_jsx("div", { className: classNames(cls.NotFoundPage, {}, [className]), children: _jsx(Error, { type: "404" }) }));
};
